export function getArrayType(typeChecker) {
    const typeCheckerAny = typeChecker;
    const arraySymbol = typeCheckerAny.createArrayType(typeCheckerAny.getAnyType()).symbol;
    return typeChecker.getDeclaredTypeOfSymbol(arraySymbol);
}

//# sourceMappingURL=types.js.map
